import React, { createContext, useContext, useEffect, useState } from "react";

// Create Context
const BefundbogenContext = createContext(null);

// 2LocalStorage key (single source of truth)
const STORAGE_KEY = "befundbogen-data";

// 3️Provider Component
export function BefundBogenProvider({ children }) {
  // This will store BOTH form payload and diagnosis result later
  const [befundData, setBefundData] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      // console.error("Failed to read Befundbogen from localStorage", err);
      return null;
    }
  });

  // Sync to localStorage on every change
  useEffect(() => {
    if (befundData !== null) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(befundData));
    }
  }, [befundData]);

  // helper to clear everything
  const clearBefundData = () => {
    setBefundData(null);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <BefundbogenContext.Provider
      value={{
        befundData,
        setBefundData,
        clearBefundData,
      }}
    >
      {children}
    </BefundbogenContext.Provider>
  );
}

// Custom Hook (clean usage)
export function useBefundBogen() {
  const context = useContext(BefundbogenContext);
  if (!context) {
    throw new Error("useBefundbogen must be used inside BefundbogenProvider");
  }
  return context;
}
